import React from "react";

// styles
import styles from "./ProgressBar.module.scss";
import cx from "classnames";
import ProgressBarSection from "./ProgressBarSection";

interface IProgressBarStage {
    sectionTitle: string;
    sectionTitleMobile: string;
    id:
        | "build"
        | "compare"
        | "apply"
        | "why"
        | "you"
        | "finances"
        | "advice"
        | "setup"
        | "details"
        | "submit";
}

interface IProgress {
    progressBarCurrentStage: IProgressBarStage["id"];
    progressBarStages: IProgressBarStage[];
}

const ProgressBar: React.FC<IProgress> = (props) => {
    const { progressBarCurrentStage, progressBarStages } = props;

    const currentIndex = progressBarStages.findIndex(
        (stage) => stage.id === progressBarCurrentStage
    );

    const getSectionState = (
        index: number
    ): React.ComponentProps<typeof ProgressBarSection>["sectionState"] =>
        currentIndex > index
            ? "previous"
            : currentIndex === index
            ? "active"
            : "upcoming";

    return (
        <div
            className={cx(
                styles["section-container"],
                "text-font-size-s",
                "layout-flex-row"
            )}>
            <div className={cx(styles["section--first"])}></div>
            {progressBarStages.map((el, index, array) => {
                return (
                    <ProgressBarSection
                        sectionTitle={progressBarStages[index]}
                        sectionState={getSectionState(index)}
                        isFinalSection={index === array.length - 1}
                        key={index}
                        sectionNumber={index + 1}
                    />
                );
            })}
            <div className={styles["section--last"]}></div>
        </div>
    );
};

export default ProgressBar;
